var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScannersEtCompteRendus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 907",
    d: "M3.875 54.25V7.75A3.88 3.88 0 0 1 7.75 3.875H46.5a3.878 3.878 0 0 1 3.875 3.875v22.781l3.875-3.875V7.75A7.75 7.75 0 0 0 46.5 0H7.75A7.75 7.75 0 0 0 0 7.75v46.5A7.75 7.75 0 0 0 7.75 62h21.313v-3.875H7.75a3.88 3.88 0 0 1-3.875-3.875Zm38.75-42.625h-31V15.5h31Zm0 7.75h-31v3.875h31Zm0 7.75h-31V31h31Zm-31 11.625h15.5v-3.875h-15.5Zm49.24-3.875-2.74-2.74a3.873 3.873 0 0 0-5.479 0L36.01 48.771c-.757.757-3.073 3.684-3.073 4.675L31 62l8.552-1.937a47.137 47.137 0 0 0 4.677-3.073l16.636-16.636a3.873 3.873 0 0 0 0-5.479Zm-18 20.741a19.289 19.289 0 0 1-1.906 1.311l-5.02-5.02a17.218 17.218 0 0 1 1.442-1.767l12.525-12.525 5.48 5.48Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannersEtCompteRendus);
export default __webpack_public_path__ + "static/media/scanners-et-compte-rendus.ce5aaddf7fd63ae7e528f189019ce5bb.svg";
export { ForwardRef as ReactComponent };